const GallerySvg = ({ fill, ...rest }) => {
  return (
    <div>
      <svg
        width="27"
        height="27"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 430.23 430.23"
        {...rest}
      >
        <path
          d="M217.875 159.668c-24.237 0-43.886 19.648-43.886 43.886 0 24.237 19.648 43.886 43.886 43.886 24.237 0 43.886-19.648 43.886-43.886 0-24.238-19.648-43.886-43.886-43.886zm0 66.873c-12.696 0-22.988-10.292-22.988-22.988s10.292-22.988 22.988-22.988 22.988 10.292 22.988 22.988-10.292 22.988-22.988 22.988z"
          fill={fill}
        />
        <path
          d="M392.896 59.357L107.639 26.966a39.18 39.18 0 00-30.824 8.882 39.705 39.705 0 00-15.151 27.167l-5.224 42.841H40.243c-22.988 0-40.229 20.375-40.229 43.363V362.9c-.579 21.921 16.722 40.162 38.644 40.741.528.014 1.057.017 1.585.01h286.824c22.988 0 43.886-17.763 43.886-40.751v-8.359a52.242 52.242 0 0019.853-8.359 43.366 43.366 0 0015.151-28.212l24.033-212.114c2.45-23.041-14.085-43.768-37.094-46.499zM350.055 362.9c0 11.494-11.494 19.853-22.988 19.853H40.243c-10.383.305-19.047-7.865-19.352-18.248a18.68 18.68 0 01.021-1.605v-38.661l80.98-59.559c9.728-7.469 23.43-6.805 32.392 1.567l56.947 50.155a49.114 49.114 0 0030.825 11.494 47.542 47.542 0 0025.078-6.792l102.922-59.559V362.9zm0-125.91l-113.894 66.351a26.645 26.645 0 01-30.825-2.612l-57.469-50.678c-16.471-14.153-40.545-15.021-57.992-2.09l-68.963 50.155V149.219c0-11.494 7.837-22.465 19.331-22.465h286.824c12.28.509 22.197 10.201 22.988 22.465v87.771zm59.057-133.955c-.007.069-.013.139-.021.208l-24.555 212.114a17.762 17.762 0 01-6.792 14.106c-2.09 2.09-6.792 3.135-6.792 4.18V149.219c-.825-23.801-20.077-42.824-43.886-43.363H77.337l4.702-40.751a24.034 24.034 0 017.837-13.584 24.032 24.032 0 0115.674-4.18l284.735 32.914c11.488 1.091 19.918 11.29 18.827 22.78z"
          fill={fill}
        />
      </svg>
    </div>
  );
};

export default GallerySvg;
